import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Flex, message, Modal } from 'antd'
import { PromoCodeItem } from 'Modules'

import { PROMO_CODE_MESSAGES } from 'constants/promo-code'
import { useDeletePromoCode } from 'hooks/promo-code'

interface DeletePromoCodeModalProps {
  open: boolean
  promoCode: PromoCodeItem | null
  onClose: () => void
}

export const DeletePromoCodeModal = ({ open, promoCode, onClose }: DeletePromoCodeModalProps) => {
  const deletePromoCode = useDeletePromoCode()
  const loading = deletePromoCode.isPending

  const handleDelete = async () => {
    if (!promoCode) return
    try {
      await deletePromoCode.mutateAsync(promoCode.id)
      message.success(PROMO_CODE_MESSAGES.DELETE_SUCCESS)
      onClose()
    } catch (e: any) {
      message.error(e?.message || 'Failed to delete promo code')
    }
  }

  return (
    <Modal
      open={open}
      title={
        <Flex gap={8} align="start">
          <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: 20, marginTop: 2 }} />
          <Flex vertical>
            <div>Delete Confirm</div>
            <div style={{ fontSize: 12, color: '#6a7282', fontWeight: 400 }}>
              This action cannot be undone
            </div>
          </Flex>
        </Flex>
      }
      onCancel={onClose}
      closable={!loading}
      maskClosable={!loading}
      centered
      destroyOnClose
      footer={() => (
        <>
          <Button disabled={loading} onClick={onClose}>
            Cancel
          </Button>
          <Button color="danger" variant="solid" loading={loading} onClick={handleDelete}>
            Delete
          </Button>
        </>
      )}
    >
      Are you sure you want to delete code {promoCode?.code}?
    </Modal>
  )
}
